/**
 *
 * Modal
 *
 */
import * as PropTypes from "prop-types";
import styled from "styled-components";
import { Modal as MaterialModal } from "@material-ui/core";

function Modal({ open, children, onClose }) {
  return (
    <MaterialModal open={open} onClose={onClose}>
      <Overlay onClick={onClose}>{children}</Overlay>
    </MaterialModal>
  );
}

Modal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.any,
};

function noop() {}
Modal.defaultProps = {
  onClose: noop,
};

export default Modal;

const Overlay = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
`;
